<template>
  <v-dialog scrollable max-width="1200px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" block small>CLONAR DE</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h4>Clonar Bolsa</h4>
      </v-card-title>
      <v-card-text>
        <v-progress-linear
          indeterminate
          rounded
          :active="loading"
        ></v-progress-linear>

        <v-data-table dense :items="escenarios" :headers="headers">
          <template v-slot:[`item.actions`]="props">
            <v-btn
              v-if="props"
              small
              color="primary"
              @click="clonar(props.item)"
              >Seleccionar</v-btn
            >
          </template>
        </v-data-table>
        <h4 v-if="errorMessage" class="pa-3 red--text">{{ errorMessage }}</h4>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>

        <Confirmar
          v-if="escenarioNew"
          boton="Clonar"
          titulo="Copiar reglas "
          :texto="
            'Desea copiar las reglas de: <br><br>' +
            this.escenario.nombre +
            '<br>a<br>' +
            this.escenarioNew.nombre
          "
          @si="clonar"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
// import EscenarioAutocomplete from "@/components/shared/EscenarioAutocomplete.vue";
import Confirmar from "@/components/Confirmar.vue";

import axios from "axios";

export default Vue.extend({
  props: ["generacionId"],
  components: { Confirmar },
  data() {
    return {
      loading: false,
      errorMessage: "",
      showDialog: false,
      escenarioNew: null,
      escenarios: [],
      nuevoMonto: 0,
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      headers: [
        { text: "estadoGeneracion", value: "estadoGeneracion" },
        { text: "nombreGeneracion", value: "nombreGeneracion" },
        { text: "nombreEscenario", value: "nombreEscenario" },
        { text: "estadoEscenario", value: "estadoEscenario" },
        { text: "", value: "actions" },
      ],
      validForm: false,
    };
  },
  mounted() {
    //console.log('********************', this.escenario)

    axios
      .get(`/escenario/escenariosGeneracion`)
      .then((response) => {
        console.log(response);
        this.escenarios = response.data;
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data) {
          this.errorMessage = err.response.data;
        } else {
          this.errorMessage = "Error";
        }
      });
  },
  methods: {
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    clonar(item) {
      // setTimeout(() => {
      //   this.$emit("clonado", this.generacioNew );
      //   this.close();
      // }, 500);

      if (
        !confirm(
          "Desea crear aquí, una copia de " +
            item.nombreGeneracion +
            " - ESCENARIO: " +
            item.nombreEscenario +
            " ?"
        )
      )
        return;

      this.loading = true;

      axios
        .post(
          `/bolsa/clonar/?escenarioId=${item.escenarioId}&generacionId=${this.generacionId}`
        )
        .then(() => {
          this.loading = true;
          this.$emit("clonado");
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    setEscenario(escenario) {
      this.escenarioNew = escenario;
    },
  },
});
</script>
